import { useCallback } from "react";
import { useSearchParams } from "react-router";
import JourneySendRemindersModal from "./JourneySendRemindersModal";

/**
 * URL query parameter that drives the journey reminders modal.
 * Any page that mounts `<SendJourneyRemindersById />` will open the modal
 * whenever this param is present in the URL.
 */
export const REMINDERS_JOURNEY_ID_PARAM = "remindersJourneyId";

/**
 * Behavior component that opens the Send Reminders modal when a journey id
 * appears in the URL.
 *
 * Mount once on any page that should support deep-linking into reminders —
 * the modal opens when `?remindersJourneyId=<id>` appears in the URL and
 * closes by removing the param. Callers anywhere in the tree just need to
 * call `setSearchParams({ remindersJourneyId })` to trigger it.
 */
export default function SendJourneyRemindersById() {
  const [searchParams, setSearchParams] = useSearchParams();
  const journeyId = searchParams.get(REMINDERS_JOURNEY_ID_PARAM) ?? undefined;

  const handleClose = useCallback(() => {
    // `replace` so the close doesn't leave a "back-button reopens modal" entry
    // in history — matches the typical X-to-dismiss user expectation.
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(REMINDERS_JOURNEY_ID_PARAM);
        return next;
      },
      { replace: true },
    );
  }, [setSearchParams]);

  return (
    <JourneySendRemindersModal
      journeyId={journeyId}
      isOpen={!!journeyId}
      onClose={handleClose}
    />
  );
}
